import React, {useMemo, useState} from 'react'
import AnimateHeight from 'react-animate-height'
import {useSelector} from 'react-redux'
import moment from 'moment'
import _, { isEmpty } from 'lodash'

import { getBrand } from '../../../redux/reducers/configuration'
import { onEnter } from '../../../utilities/accessibility/onEnter'
import { addBrandCurrencyPrefixSuffix } from '../../../utilities/currency/formatPrice'
import '../../../styles/scss/elements/monthly-availability.scss'

const MonthlyAvailability = ({availability, isInitiallyExpanded, month, onSelectDate, selectedDate}) => {
  const brand = useSelector(getBrand)
  const [expanded, setExpanded] = useState(isInitiallyExpanded)
  const availabilityKeyedByDate = useMemo(() => {
    return _.reduce(availability, (obj, item) => ({
      ...obj,
      [item.date]: item,
    }), {})
  }, [availability]);
  const daysOfMonth = useMemo(() => {
    const dates = [];
    const date = moment(month).startOf('month');
    while (date.isSame(month, 'month')) {
      dates.push(date.format('YYYY-MM-DD'));
      date.add(1, 'day');
    }
    return dates
  }, [month]);
  const buttonClassName = isEmpty(availability)
    ? ''
    : expanded
    ? 'arrow-up'
    : 'arrow-down'
  return (
    <li className="u-full-width u-flex u-flex-column monthly-availability">
      <button
        aria-label={moment(month).format('MMMM YYYY')}
        className={`u-flex ${buttonClassName}`}
        disabled={_.isEmpty(availability)}
        onClick={() => setExpanded(!expanded)}
        onKeyDown={event => onEnter(event, () => setExpanded(false))}
      >
        {moment(month).format('MMMM YYYY')}
        {_.isEmpty(availability) && <span>Call for pricing</span>}
      </button>
      <AnimateHeight height={expanded ? 'auto' : 0}>
        <ul className="u-flex u-flex-column">
          {_.map(daysOfMonth, date => {
            const item = availabilityKeyedByDate[date]
            return (
              <li key={date}>
                <button
                  aria-label={
                    item
                      ? `${moment(item.date).format('MMMM D, YYYY')} - ${addBrandCurrencyPrefixSuffix(brand, item.amount)}`
                      : 'Call for pricing'
                  }
                  className={`u-full-width u-flex u-flex-space-between ${!!item && selectedDate === item.date ? 'monthly-selected-date' : ''}`}
                  disabled={!item || item.saleStatus === 'S'}
                  onClick={() => onSelectDate(item)}
                  onKeyDown={event => onEnter(event, () => onSelectDate(item))}
                >
                  <span className="monthly-day-label">
                    {moment(date).format('MMMM D, YYYY')}
                  </span>
                  <div>
                    {!item && <span className="call-for-pricing">Call for pricing</span>}
                    {!!item && item.saleStatus !== 'S' && 
                      item.amount !== 0 &&
                      addBrandCurrencyPrefixSuffix(brand, item.amount) && 
                      <span className='from-label'>From</span>}
                    {!!item && (
                      <span>
                        {item.saleStatus === 'S'
                          ? 'SOLD OUT'
                          : item.amount !==0
                          ? addBrandCurrencyPrefixSuffix(brand, item.amount)
                          : <span className="call-for-pricing">Call for pricing</span>}
                      </span>
                    )}
                  </div>
                </button>
              </li>
            )
          })}
        </ul>
      </AnimateHeight>
    </li>
  )
}

export default MonthlyAvailability
